import {useAuthStore} from "@/store/auth_store";
import {useRosterStore} from "@/store/roster_store";
import {EventFilterPermissions} from "@/api/dto/client-profile";
import {useMemo} from "react";
import PermissionsHelpers from "@/helpers/permissions_helpers";
import {DataPermissionLevel, DataPermissionLevelNew, DataSource} from "@/api/dto/permissions";
import {FeatureToggle} from "@/api/dto/dto";
import {useFeatureToggles} from "@/hooks/useFeatureToggles";

export function useEventFilterPermissions(): EventFilterPermissions {
  const currentUser = useAuthStore((state) => state.currentUser);
  const currentRoster = useRosterStore((state) => state.currentRoster);
  const {checkBooleanToggle} = useFeatureToggles();

  const isNewPermissionsEnabled = checkBooleanToggle(FeatureToggle.CARECO_3415_NEW_USER_PERMISSIONS) ?? false;

  return useMemo(() => {
    if (!currentUser || !currentRoster) {
      return {
        jiEnabled: false,
        openBedsReferralEnabled: false,
        openBedsCrisisEnabled: false,
        findHelpSdohEnabled: false,
        adtEnabled: false
      };
    }

    return {
      jiEnabled: (isNewPermissionsEnabled ?
        PermissionsHelpers.canForUserDataPermissionRosterNew(
          currentUser,
          currentRoster,
          DataPermissionLevelNew.VIEW,
          DataSource.JI
        ) : PermissionsHelpers.canForUserDataPermissionRoster(
          currentUser,
          currentRoster,
          DataPermissionLevel.READ,
          DataSource.JI
        )) ?? false,
      openBedsReferralEnabled: (isNewPermissionsEnabled ?
        PermissionsHelpers.canForUserDataPermissionRosterNew(
          currentUser,
          currentRoster,
          DataPermissionLevelNew.VIEW,
          DataSource.OB_REFERRALS
        ) : PermissionsHelpers.canForUserDataPermissionRoster(
          currentUser,
          currentRoster,
          DataPermissionLevel.READ,
          DataSource.OB_REFERRALS
        )) ?? false,
      openBedsCrisisEnabled: (isNewPermissionsEnabled ?
        PermissionsHelpers.canForUserDataPermissionRosterNew(
          currentUser,
          currentRoster,
          DataPermissionLevelNew.VIEW,
          DataSource.OB_CRISIS
        ) : PermissionsHelpers.canForUserDataPermissionRoster(
          currentUser,
          currentRoster,
          DataPermissionLevel.READ,
          DataSource.OB_CRISIS
        )) ?? false,
      findHelpSdohEnabled: (isNewPermissionsEnabled ?
        PermissionsHelpers.canForUserDataPermissionRosterNew(
          currentUser,
          currentRoster,
          DataPermissionLevelNew.VIEW,
          DataSource.FINDHELP
        ) : PermissionsHelpers.canForUserDataPermissionRoster(
          currentUser,
          currentRoster,
          DataPermissionLevel.READ,
          DataSource.FINDHELP
        )) ?? false,
      adtEnabled: (isNewPermissionsEnabled ?
        PermissionsHelpers.canForUserDataPermissionRosterNew(
          currentUser,
          currentRoster,
          DataPermissionLevelNew.VIEW,
          DataSource.ADT
        ) : PermissionsHelpers.canForUserDataPermissionRoster(
          currentUser,
          currentRoster,
          DataPermissionLevel.READ,
          DataSource.ADT
        )) ?? false,
    };
  }, [currentUser, currentRoster, isNewPermissionsEnabled]);
}
